"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _package = _interopRequireDefault(require("../../../package.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Add more versions if they are useful e.g. theme schema version
var _default = exports.default = {
  uds: _package.default.version
};